import { createContext, useContext } from "react";

export const EditorMetaContext = createContext<{
  productId?: string;
  locale?: string;
}>({
  productId: undefined,
  locale: "en",
});

export function useEditorMeta() {
  return useContext(EditorMetaContext);
}
